import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { Icon } from './Icon.js';
import styles from './ClientHeader.module.css';

interface ClientHeaderProps {
  title: string;
  subtitle?: string;
  backTo?: string;
  backLabel?: string;
  action?: ReactNode;
}

/** Top bar of the client screens: back arrow, centred title, one action. */
export function ClientHeader({ title, subtitle, backTo, backLabel, action }: ClientHeaderProps) {
  return (
    <header className={styles.bar}>
      <div className={styles.side}>
        {backTo && (
          <Link to={backTo} className={`btn-icon btn-icon--quiet ${styles.back}`} aria-label={backLabel}>
            <Icon name="arrow-left" />
          </Link>
        )}
      </div>
      <div className={styles.title}>
        <h1>{title}</h1>
        {subtitle && <p>{subtitle}</p>}
      </div>
      <div className={`${styles.side} ${styles.sideEnd}`}>{action}</div>
    </header>
  );
}
